var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"text","pattern":"[0-9]*","inputmode":"numeric"},domProps:{"value":_vm.inputValue},on:{"input":_vm.handleInput,"blur":_vm.formatPrice,"keyup":_vm.handleKeyDown}})
}
var staticRenderFns = []

export { render, staticRenderFns }